__turbopack_context__.v({
  "label__active": "NewCalculatorSlider-module-scss-module__DJzkDq__label__active",
  "slider_block": "NewCalculatorSlider-module-scss-module__DJzkDq__slider_block",
  "slider_cost": "NewCalculatorSlider-module-scss-module__DJzkDq__slider_cost",
  "slider_cost__iconBox": "NewCalculatorSlider-module-scss-module__DJzkDq__slider_cost__iconBox",
  "slider_percent": "NewCalculatorSlider-module-scss-module__DJzkDq__slider_percent",
  "withoutPadding": "NewCalculatorSlider-module-scss-module__DJzkDq__withoutPadding",
});
